<template>
	<div class="Home">
		<HeaderPage> </HeaderPage>

		<el-card shadow="never" :body-style="{ padding: '0px' }" style="background-color: transparent; border: none; max-width: 2500px; min-height: auto">
			<!-- <ModalNotification> </ModalNotification> -->

			<div class="dashboard-geral" v-if="$can('5')">
				<el-row :gutter="10">
					<el-col :lg="18" :sm="18" :xs="24">
						<el-col :lg="12" :sm="12" :xs="24" class="graph-card">
							<ProgressaoTPV style="margin: 0px auto 0px; min-height: auto; max-width: 100%; height: 515px" />
						</el-col>

						<el-col :xs="24" :lg="12" v-if="1 == 2">
							<VendasFalhadas :query-search="rangeDateFilter" style="margin: 0px auto 0px; min-height: auto; max-width: 100%" />
						</el-col>
					</el-col>
					<el-col :lg="6" :sm="6" :xs="24" class="card-dash-small">
						<el-row :gutter="20" :span="20" class="mb-30">
							<el-col :xs="24" :lg="24" class="graph-card">
								<TicketMedio :query-search="rangeDateFilter" />
							</el-col>
						</el-row>
						<el-row :gutter="10" :span="20" class="mb-30">
							<el-col :xs="24" :lg="24" class="graph-card">
								<QuantidadeTransacao :query-search="rangeDateFilter" />
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>

			<div class="dashboard-geral" v-if="$can('1|2|3|4|6|')">
				<el-row :gutter="10">
					<el-col :lg="18" :sm="18" :xs="24">
						<el-col :lg="12" :sm="24" :xs="24" class="graph-card">
							<ProgressaoTPV style="margin: 0px auto 0px; min-height: auto; max-width: 100%" />
						</el-col>
						<el-col :lg="12" :sm="24" :xs="24" class="graph-card">
							<ProgressaoMarkups style="margin: 0px auto 0px; min-height: auto; max-width: 100%" />
						</el-col>
					</el-col>
					<el-col :lg="6" :sm="6" :xs="24" class="card-dash-small">
						<el-row :gutter="20" :span="20" class="mb-30">
							<el-col :xs="24" :lg="24" class="graph-card">
								<TicketMedio :query-search="rangeDateFilter" />
							</el-col>
						</el-row>
						<el-row :gutter="10" :span="20" class="mb-30">
							<el-col :xs="24" :lg="24" class="graph-card">
								<QuantidadeTransacao :query-search="rangeDateFilter" />
							</el-col>
						</el-row>
						<el-row :gutter="20" :span="20" class="graph-card">
							<el-col :xs="24" :lg="24">
								<PercentualMarckup :query-search="rangeDateFilter" />
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row :gutter="20" style="height: 525px" v-if="1 == 2">
					<el-col :lg="8" :sm="24" :xs="24" style="padding-left: 20px">
						<ProgressaoEC style="margin: 20px auto 0; min-height: auto; max-width: 100%" />
					</el-col>
					<el-col :xs="24" :lg="8">
						<VendasFalhadas :query-search="rangeDateFilter" style="margin: 20px auto 0; min-height: auto; max-width: 100%" />
					</el-col>
					<el-col :xs="24" :lg="8" v-if="!$can('5')">
						<VendasPorTipo :query-search="rangeDateFilter" style="margin: 20px auto 0; min-height: auto; max-width: 100%" />
					</el-col>
				</el-row>
			</div>

		</el-card>
	</div>
</template>

<script>
	import { mapGetters } from "vuex"
	import HeaderPage from "@/app/components/HeaderPage"
	import ProgressaoMarkups from "@/app/domains/Core/components/graphs/ProgressaoMarkups"
	import ProgressaoTPV from "@/app/domains/Core/components/graphs/ProgressaoTPV"
	import VendasFalhadas from "@/app/domains/Core/components/graphs/VendasFalhadas"
	import VendasPorTipo from "@/app/domains/Core/components/graphs/VendasPorTipo"
	import ProgressaoEC from "@/app/domains/Core/components/graphs/ProgressaoEC"
	import PercentualMarckup from "@/app/domains/Core/components/graphs/PercentualMarckup"
	import TicketMedio from "@/app/domains/Core/components/graphs/TicketMedio"
	import QuantidadeTransacao from "@/app/domains/Core/components/graphs/QuantidadeTransacao"
	// import ModalNotification from "@/app/domains/Core/components/parts/ModalNotification";

	export default {
		name: "Dashboard",
		components: {
			HeaderPage,
			ProgressaoMarkups,
			ProgressaoTPV,
			ProgressaoEC,

			PercentualMarckup,
			TicketMedio,
			VendasFalhadas,
			VendasPorTipo,
			QuantidadeTransacao

			// ModalNotification
		},
		computed: {
			...mapGetters("Auth", ["currentAccount", "currentUser"])
		},
		data() {
			return {
				rangeDateFilter: [this.$moment().subtract("months", 1).format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
				pickerOptions: {
					shortcuts: [
						{
							text: "Semana Anterior",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
								picker.$emit("pick", [start, end])
							}
						},
						{
							text: "Mês passado",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
								picker.$emit("pick", [start, end])
							}
						},
						{
							text: "Últimos 3 meses",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
								picker.$emit("pick", [start, end])
							}
						}
					]
				}
			}
		},
    mounted() {}
	}
</script>

<style scoped></style>

